import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { resultLabel } from "@/hooks/useDailyTrade";

export function GameNotice() {
  return (
    <aside className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 my-3 text-xs leading-relaxed text-amber-200">
      <Link to="/game-policy" className="underline font-semibold">Read game policy</Link>
      {" · "}
      <Link to="/how-to-play" className="underline font-semibold">How to Play</Link>
    </aside>
  );
}

export function GameEntryDialog({ entry, onClose, onConfirm, busy, resultAt }) {
  const [accepted, setAccepted] = useState(false);
  return (
    <Dialog open={!!entry} onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
      <DialogContent className="bg-[#121721] border-[#334155] text-white max-w-sm rounded-xl max-h-[85dvh] overflow-y-auto">
        <DialogTitle>Confirm game entry</DialogTitle>
        <p className="text-sm">
          {entry?.symbol} &middot; {entry?.direction?.toUpperCase()} &middot; One entry per day.
        </p>
        <p className="text-sm text-emerald-300">Results: {resultLabel(resultAt)}.</p>
        <p className="text-sm text-slate-300">
          Your balance and tier at settlement determine the amount. Losses use half the tier&apos;s win rate.
          There is no fixed payout. The final deduction can differ if your balance or tier changes.
          Results settle at the admin&apos;s daily time. A schedule change moves all pending scheduled entries.
          The winning direction locks after the first entry.
        </p>
        <Link to="/game-policy" className="text-sm text-emerald-400 underline" onClick={onClose}>
          Read game policy
        </Link>
        <label className="flex items-start gap-2 text-sm">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="mt-1"
          />
          I accept the tier rates in the policy, understand that the admin determines the outcome,
          and can lose up to 7.5% of my settlement balance.
        </label>
        <Button
          disabled={!accepted || busy}
          onClick={() => accepted && onConfirm()}
          className="bg-emerald-400 text-black font-semibold"
        >
          {busy ? "Submitting..." : "Accept rules and enter"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
